import React from 'react'
import { Link } from 'react-router-dom'
import tdah from '../assets/images/psicologo/tdah.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${tdah})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">TDAH</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">TDAH</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

  <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          El Trastorno por Déficit de Atención e Hiperactividad (TDAH) es una condición neurobiológica que afecta la capacidad de una persona para mantener la atención, controlar impulsos y regular la actividad física. Aunque se diagnostica con frecuencia en la infancia, puede persistir en la adolescencia y la adultez, interfiriendo en el rendimiento académico, laboral y social.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el TDAH?</h4>
        <p className="text-muted">
          El TDAH no es falta de disciplina ni pereza. Es un trastorno que involucra diferencias en el funcionamiento y la conectividad de áreas cerebrales como la corteza prefrontal y los ganglios basales. Desde la neuromodulación, se busca mejorar la comunicación entre estas áreas y optimizar la capacidad de concentración y autocontrol.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: inquietud motora constante, necesidad de moverse o cambiar de posición con frecuencia.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: dificultad para mantener la atención, olvidos frecuentes y desorganización, tendencia a distraerse fácilmente.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: interrupción frecuente de conversaciones, impulsividad en la toma de decisiones, dificultad para esperar turnos.
        </p>
        
        <br />
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): estimula áreas prefrontales para mejorar la atención y el control de impulsos.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): favorece la planificación y la organización mediante modulación neuronal.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrena al cerebro para mantener un estado óptimo de concentración.
        </p>
      </div>
    </div>
  </div>
</section>
    
    <Footer/>
    </>
  )
}
